import React from 'react'
import CompareNote from './CompareNote'
import DayReflectionNote from './DayReflectionNote'
import '../styles/Note.css'
import { useTranslation } from 'react-i18next'

export default function Note({ note, close }) {
    const { t } = useTranslation()

    return (
        <div className="note-container">
            {note.type === 'daily_feedback' && <CompareNote note={note} />}
            {note.type === 'day_reflection' && <DayReflectionNote note={note} />}

            <div className="note-action-box">
                <button className="danger-button">{t('deleteNote')}</button>
            </div>
        </div>
    )
}
